import { WprBaseValidator } from './WprBaseValidator';
import { WprControlInfo } from '../control/WprControlInfo';
import { WprValidError } from './WprValidError';
import { WprValidErrorInfo } from './WprValidErrorInfo';
import { WprInvalidInfo } from './WprInvalidInfo';

/**
 * バリデーション情報
 */
export class WprValidatorInfo {
	// private 変数  ------------------------------------------------------------
	private m_Description: string			= null;			// 説明
	private m_Validator: WprBaseValidator	= null;			// バリデータ
	private m_Option: any					= undefined;	// オプション
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** バリデータ */
	public get validator(): WprBaseValidator 	{ return this.m_Validator; 	}
	/** オプション */
	public get option(): any 					{ return this.m_Option; 	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor(description: string, validator: WprBaseValidator, option?: any) {
		this.m_Description = description;
		this.m_Validator = validator;
		this.m_Option = option;
	}
	// --------------------------------------------------------------------------

	// public メソッド  ----------------------------------------------------------
	/**
	 * 入力値チェック
	 * @param value 入力値
	 * @returns trueの場合、成功
	 */
	public checkValidValue(value: any): boolean {
		return this.m_Validator.checkValidValue(value, this.m_Option);
	}

	/**
	 * 入力チェック処理
	 * @param value 入力値
	 * @return falseの場合、入力無効
	 */
	public checkInput(value: any): boolean {
		return this.m_Validator.checkInput(value, this.m_Option);
	}

	/**
	 * バリデーションエラー情報取得
	 * @returns バリデーションエラー情報
	 */
	public getInvalidInfo(): WprInvalidInfo {
		return new WprInvalidInfo(this.m_Validator.name, this.m_Option, this.m_Validator.getErrorMessage(this.m_Description, this.m_Option));
	}

	/**
	 * エラー情報設定処理
	 * @param cinfo コントロール情報
	 * @param validError: 入力エラー情報
	 */
	public setErrorInfo(cinfo: WprControlInfo, validError: WprValidError): void {
		let message = this.m_Validator.getErrorMessage(this.m_Description, this.m_Option);
		const customMsg = this.m_Validator.getCustomMessage(this.m_Description);
		if (customMsg)
			 message = customMsg;
		const errInfo = new WprValidErrorInfo(cinfo.name, cinfo.description, cinfo.rowIndex, this.m_Validator.name, this.m_Option, message);
		errInfo.isCustom = this.m_Validator.isCustom;
		validError.addErrorInfo(errInfo);
	}
	// --------------------------------------------------------------------------
}
